// extracted by mini-css-extract-plugin
export var active = "_d6-7";
export var container = "_d6-0";
export var evenWidth = "_d6-4";
export var large = "_d6-5";
export var outlet = "_d6-8";
export var slide = "_d6-2";
export var small = "_d6-6";
export var tab = "_d6-3";
export var tabs = "_d6-1";